import {
    Dialog,
    DialogTitle,
    DialogContent,
    Stack,
    IconButton,
    CircularProgress,
    Box,
    DialogActions,
    DialogContentText,
    Button,
    Typography,
    styled
} from '@mui/material';

import { Icon } from '@iconify/react';
import BlockIcon from '@mui/icons-material/Block';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import { Menu, MenuItem, ListItemIcon} from '@mui/material';
import { useCallback, useRef, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import {useAddVaultConnection, useAuthorizeVaultConnection, useDisconnectConnection, useUpdateConnectionConfiguration} from './useVaultConnection';
import { LoadingButton } from '@mui/lab';
import { useLocation } from 'react-router';
import { FormWithRedirect, SaveButton, Toolbar as AdminToolbar, useNotify } from 'react-admin';
import VaultConnectionJobberForm from './VaultConnectionJobberForm';
import VaultConnectionAspireForm from './VaultConnectionAspireForm';
import VaultConnectionTSheetForm from './VaultConnectionTSheetForm';
import VaultConnectionBusyBusyForm from './VaultConnectionBusyBusyForm';
import { useQueryClient } from 'react-query';
import _ from 'lodash';
import VaultConnectionBuddypunchForm from './VaultConnectionBuddypunch';


export const VaultConnectionCardDialog = ({open, connection, handleClose}) => {
    const {search} = useLocation()
    const params = new URLSearchParams(search);
    const [isOpen, setIsOpen] = useState(false);
    const [error, setError] = useState("");
    const notify = useNotify();
    const closeMenu = useCallback(()=>{
      setIsOpen(false);
      handleClose();
    },[handleClose, setIsOpen])
    const configurationKeys = Object.keys(connection.configuration);
    const {updateConnectionConfiguration, isLoading:isLoadingSaveConfiguration} = useUpdateConnectionConfiguration()
    const {addConnection, isLoading: isLoadingAddVault} = useAddVaultConnection()
    const {authorizeConnection, isLoading: isLoadingAuthorizeVault} = useAuthorizeVaultConnection()
    const onClickAuthorize = useCallback((data:any) => {
        console.log("onClickAuthorize", data)
        setError("")
        addConnection({number:connection.number || 1,service_id: connection.service, redirect_uri:window.location.href, configuration: data}, {
            onSuccess:(connection)=>{
                console.log("Connection added", connection, connection.authorization_url)
                if(!_.isEmpty(connection.authorization_url)){
                    window.location = connection.authorization_url

                } else {
                    authorizeConnection({id: connection.id, service_id: connection.service, configuration: data}, {
                        onSuccess:(authorization)=>{
                            handleClose();
                        },
                        onError: (error) => {
                            console.log("Create authorize failure response:", error)
                            setError(error.error.message);
                            notify(`${error.error.message}`);
                        },
                    })
                }
            }

        })
    },[connection, addConnection])

    const onClickSave = useCallback((data:any)=>{
        console.log("onClickSave", data)
        setError("")
        updateConnectionConfiguration(connection.id, {configuration: data}, {
            onSuccess:(connection)=>{
                console.log("Connection configuration saved", connection)
                if(!_.isEmpty(connection.authorization_url)){
                    handleClose();
                } else {
                    authorizeConnection({id: connection.id, service_id: connection.service, configuration: data}, {
                        onSuccess:(authorization)=>{
                            console.log("authorization:",authorization)
                            handleClose();
                        },
                        onError: (error) => {
                            console.log("Create authorize failure response:", error)
                            setError(error.error.message);
                            notify(`${error.error.message}`);
                        },
                    })
                }

            }

        })
    },[connection, updateConnectionConfiguration, handleClose])


    const loading = isLoadingAddVault || isLoadingAuthorizeVault;
    const saveLoading = isLoadingSaveConfiguration || isLoadingAuthorizeVault;
    return (
        <FormWithRedirect initialValues={connection.configuration} render={(formProps: any) => {
            return (
                <Dialog
                    open={open}
                    maxWidth="sm"
                    sx={{
                        '.MuiDialog-paper .MuiDialogActions-root': {
                            paddingTop: 0,
                        },
                    }}
                >
                    <DialogTitle
                        style={{ cursor: 'move' }}
                        id="draggable-dialog-title"
                    >
                        <Stack
                            flexDirection={'row'}
                            justifyContent={'space-between'}
                        >
                            <ConnectionDialogMoreMenu isOpen={isOpen} setIsOpen={setIsOpen}>
                            <MenuItem className='busy-busy-disconnect-loader'>
                                <ListItemIcon>
                                    <BlockIcon />
                                    </ListItemIcon>
                                    <DisconnectMenuItem connection={connection} closeMenu={closeMenu}/>
                                </MenuItem>
                            </ConnectionDialogMoreMenu>
                            <div id="react-admin-dialog-title" >{connection.name}</div>
                            <IconButton
                                color="primary"
                                aria-label="cancel"
                                onClick={handleClose}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Stack>
                    </DialogTitle>
                    <DialogContent sx={{ pb: 0 }}>
                    <Stack
                        direction="column"
                        alignItems="center"
                        sx={{pb: 2, pl: 0, pr: 0 }}
                    >
                        <Box sx={{pb:2}}>
                            <img
                                src={connection.logo}
                                alt={connection.name}
                                loading="lazy"
                                height={100}
                                className='vault-setting-img'
                            />

                        </Box>
                        <Box sx={{mb:2}}>
                            {connection.service === 'jobber' && <VaultConnectionJobberForm configurationKeys={configurationKeys}/>}
                            {connection.service === 'aspire' && <VaultConnectionAspireForm configurationKeys={configurationKeys}/>}
                            {connection.service === 'tsheet' && <VaultConnectionTSheetForm configurationKeys={configurationKeys}/>}
                            {connection.service === 'buddypunch' && <VaultConnectionBuddypunchForm configurationKeys={configurationKeys}/>}
                            {(connection.service.startsWith("apify-") || connection.service === 'busybusy' || connection.service === 'arborgold' || connection.service === 'exaktime') && <VaultConnectionBusyBusyForm service={connection.service} />}
                        </Box>
                        <Typography variant="body2" color="error">
                        {params.get('error')}
                        </Typography>
                        <Typography variant="body2" color="error">
                        {error}
                        </Typography>
                    </Stack>

                    </DialogContent>
                    <StyledDialogActions  sx={{
                        justifyContent:'center', padding:0,
                        margin:0,
                    }}
                    className={classes.root}>
                        <StyledToolbar
                            sx={{
                                background:'none!important',
                                padding:0,
                                margin:0,
                                minHeight:'inherit!important'
                            }}
                            record={formProps.record}
                            invalid={formProps.invalid}
                            handleSubmit={formProps.handleSubmit}
                            handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
                            saving={formProps.saving}
                            basePath={''}>

                        {(!connection.status || connection.status === "not_authorized") &&
                            <SaveButton size="large" fullWidth className='vault-authorize-button' label='Authorize' saving={loading} disabled={loading} onSave={onClickAuthorize} />}

                        {(connection.status === "authorized") &&
                            <SaveButton size="large" fullWidth className='vault-save-configuration-button' label='Save' saving={saveLoading} disabled={saveLoading} onSave={onClickSave} />}
                        </StyledToolbar>
                    </StyledDialogActions>
                </Dialog>
            );
        }}
        />
    )
};
const DisconnectMenuItem = ({connection, closeMenu}) => {
    const [open, setOpen] = useState(false);
    const queryClient = useQueryClient();
    const {disconnectConnection, isLoading:isLoadingDisconnect} = useDisconnectConnection()
    const onClickConfirmDisconnect = useCallback(()=>{
        setOpen(false)
        disconnectConnection({id: connection.id}, {
            onSuccess:(connection)=>{
                console.log("Connection disconnected", connection)
                queryClient.refetchQueries();
                closeMenu()
            },
        })
    },[setOpen, disconnectConnection, connection, closeMenu])

    const onClickDisconnect = useCallback(()=>{
        setOpen(true)
    },[setOpen])

    const onCancel = useCallback(()=>{
        setOpen(false)
    },[setOpen])


    return  (
        <>
            <LoadingButton
                disabled={isLoadingDisconnect}
                onClick={onClickDisconnect}
            >
                {isLoadingDisconnect && (
                    <CircularProgress size={25} thickness={2} />
                )}
                Disconnect
            </LoadingButton>
            <AlertDialog name={connection.name} open={open} onCancel={onCancel} onConfirm={onClickConfirmDisconnect}/>
        </>
    )
}


export default function AlertDialog({name, open, onCancel, onConfirm}) {
    return (
        <Dialog
          open={open}
          onClose={onCancel}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Alert
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
                This will stop your <b>{name}</b> integration. Are you sure you want to continue?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={onConfirm}>Continue</Button>
            <Button onClick={onCancel} autoFocus>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
    );
  }

  function ConnectionDialogMoreMenu({children, isOpen, setIsOpen}){
    const ref = useRef(null);
        return (<>
            <IconButton ref={ref} onClick={() => setIsOpen(true)}>
                <Icon fr='' icon={moreVerticalFill} width={20} height={20} />
            </IconButton>
            <Menu
                open={isOpen}
                anchorEl={ref.current}
                onClose={() => setIsOpen(false)}
                PaperProps={{
                    sx: { width: 200, maxWidth: '100%' }
                }}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
                {children}
            </Menu>
        </>)
    }

    const classes = {
        root: `DialogAction-root`,
    };

const StyledToolbar =  styled(AdminToolbar)({
    '&.RaToolbar-mobileToolbar': {
        position: 'relative'
    },
    '&.RaToolbar-toolbar':{
        backgroundColor:'#FFF'
    },
    '&.RaToolbar-desktopToolbar':{
        backgroundColor:'#FFF',
        marginTop:'unset'
    },
});

const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
    [`&.MuiDialogActions-root.${classes.root}`]: {
        padding:theme.spacing(2)
    },
}));
